import Vue from "vue";
import { CreateElement, VNode, VueConstructor } from "vue";
import { Message } from "@scrile/api-provider/dist/api/MessagesProvider";
import MessagePreview from "./MessagePreview.vue";
import MessagePreviewAutomatedPostsNoFiles from "./MessagePreviewAutomatedPostsNoFiles.vue";
import MessagePreviewCall from "./MessagePreviewCall.vue";
import MessagePreviewCustomRequest from "./MessagePreviewCustomRequest.vue";
import MessagePreviewSubscriptionLevelWarning from "./MessagePreviewSubscriptionLevelWarning.vue";
import MessagePreviewTip from "./MessagePreviewTip.vue";

export function getMessagePreview(message?: Message): VueConstructor<Vue> {
  if (message && Number(message.senderId) > 0) {
    return MessagePreview;
  }
  if (message && message.details) {
    const type = message.details.type;
    switch (type) {
      case "call":
        return MessagePreviewCall;
      case "tip":
        return MessagePreviewTip;
      case "subscription_level_warning":
        return MessagePreviewSubscriptionLevelWarning;
      case "automated_posts_no_files":
        return MessagePreviewAutomatedPostsNoFiles;
      case "custom_request":
        return MessagePreviewCustomRequest;
      default:
        return MessagePreview;
    }
  }
  return Vue.extend({
    functional: true,
    render: (h: CreateElement): VNode => h(),
  });
}
